'use es6';

export const ACCEPT_ALL_BUTTON_ID = 'hs-modal-accept-all';
export const SAVE_SETTINGS_BUTTON_ID = 'hs-modal-save-settings';
export const MODAL_ID = 'hs-modal';
export const CLOSE_BUTTON_ID = 'hs-modal-close-button';
export const INTRODUCTION_ID = 'hs-modal-introduction';
export const NECESSARY_CATEGORY_ID = 'hs-category-necessary';
export const ANALYTICS_CATEGORY_ID = 'hs-category-analytics';
export const ANALYTICS_TOGGLE_ID = 'hs-category-toggle-analytics';
export const ADVERTISEMENT_CATEGORY_ID = 'hs-category-advertisement';
export const ADVERTISEMENT_TOGGLE_ID = 'hs-category-toggle-advertisement';
export const FUNCTIONALITY_CATEGORY_ID = 'hs-category-functionality';
export const FUNCTIONALITY_TOGGLE_ID = 'hs-category-toggle-functionality';
export const getModalHtml = (cookiesByCategory, consent) => {
  const {
    acceptAllLabel,
    categories,
    introduction,
    saveSettingsLabel
  } = cookiesByCategory;
  const hasToggledAnalytics = consent.categories.analytics;
  const hasToggledAds = consent.categories.advertisement;
  const hasToggledFunctionality = consent.categories.functionality;
  return `
<div id="hs-modal" role="dialog"  aria-modal="true" data-nosnippet>
  <span id="hs-a11y-live" class="hs-sr-only" aria-live="polite"></span>
  <div id="hs-modal-content">

    <div id="hs-modal-header" aria-hidden="true">
      <div id="hs-modal-header-container">
        <span id="${CLOSE_BUTTON_ID}">&times;</span>
      </div>
    </div>

    <div id="hs-modal-body">
      <div id="hs-modal-body-container" role="tablist">
          <div class="hs-category-row" role="tab" aria-selected="true" aria-controls="${INTRODUCTION_ID}-description">
            <div id="${INTRODUCTION_ID}" class="hs-category-label hs-active" aria-label="${introduction.label}" tabindex="0">
              <span>${introduction.label}</span>
            </div>
            <div id="${INTRODUCTION_ID}-description" class="hs-category-description hs-active" aria-labelledby="${INTRODUCTION_ID}" role="tabpanel">
              <div class="hs-category-description-header">
                <h3 aria-hidden="true">${introduction.label}</h3>
              </div>
              <div class="hs-category-description-text">
                ${introduction.description}
              </div>
            </div>
          </div>
          <div class="hs-category-row" role="tab" aria-selected="false" aria-controls="${NECESSARY_CATEGORY_ID}-description">
            <div id="${NECESSARY_CATEGORY_ID}" class="hs-category-label" aria-label="${categories.necessary.label}" tabindex="0">
              <span>${categories.necessary.label}</span>
              <span id="hs-category-necessary-checked" class="hs-modal-checkmark"></span>
            </div>
            <div id="${NECESSARY_CATEGORY_ID}-description" class="hs-category-description hs-hidden" role="tabpanel">
              <div class="hs-category-description-header">
                <label class="hs-category-toggle">
                  <input type="checkbox" role="switch" aria-checked="true" aria-label="${categories.necessary.label}" checked disabled>
                  <span class="slider"></span>
                </label>
                <span class="hs-always-active-label" aria-hidden="true">${categories.necessary.toggleLabel || ''}</span>
                <h3 aria-hidden="true">${categories.necessary.label}</h3>
              </div>
              <div class="hs-category-description-text">
               ${categories.necessary.description}
              </div>
            </div>
          </div>
          <div class="hs-category-row" role="tab" aria-selected="false" aria-controls="${ANALYTICS_CATEGORY_ID}-description">
            <div id="${ANALYTICS_CATEGORY_ID}" class="hs-category-label" aria-label="${categories.analytics.label}" tabindex="0">
              <span>${categories.analytics.label}</span>
              <span id="${ANALYTICS_CATEGORY_ID}-checked" class="hs-modal-checkmark ${!hasToggledAnalytics && 'hs-hidden'}"></span>
              <span id="${ANALYTICS_CATEGORY_ID}-unchecked" class="hs-modal-cross ${hasToggledAnalytics && 'hs-hidden'}"></span>
            </div>
            <div id="${ANALYTICS_CATEGORY_ID}-description" class="hs-category-description hs-hidden" role="tabpanel">
              <div class="hs-category-description-header">
                <label class="hs-category-toggle">
                  <input id="${ANALYTICS_TOGGLE_ID}" type="checkbox" ${hasToggledAnalytics && 'checked'}  aria-label="${categories.analytics.label}" role="switch" tabindex="0">
                  <span class="slider"></span>
                </label>
                <h3 aria-hidden="true">${categories.analytics.label}</h3>
              </div>
              <div class="hs-category-description-text">
                ${categories.analytics.description}
              </div>
            </div>
          </div>
          <div class="hs-category-row" role="tab" aria-selected="false" aria-controls="${ADVERTISEMENT_CATEGORY_ID}-description">
            <div id="${ADVERTISEMENT_CATEGORY_ID}" class="hs-category-label" aria-label="${categories.advertisement.label}" tabindex="0">
              <span>${categories.advertisement.label}</span>
              <span id="${ADVERTISEMENT_CATEGORY_ID}-checked" class="hs-modal-checkmark ${!hasToggledAds && 'hs-hidden'}"></span>
              <span id="${ADVERTISEMENT_CATEGORY_ID}-unchecked" class="hs-modal-cross ${hasToggledAds && 'hs-hidden'}"></span>
            </div>
            <div id="${ADVERTISEMENT_CATEGORY_ID}-description" class="hs-category-description hs-hidden" role="tabpanel">
              <div class="hs-category-description-header">
                <label class="hs-category-toggle">
                  <input id="${ADVERTISEMENT_TOGGLE_ID}" type="checkbox" ${hasToggledAds && 'checked'} aria-label="${categories.advertisement.label}" role="switch" tabindex="0">
                  <span class="slider"></span>
                </label>
                <h3 aria-hidden="true">${categories.advertisement.label}</h3>
              </div>
              <div class="hs-category-description-text">
                ${categories.advertisement.description}
              </div>
            </div>
          </div>
          <div class="hs-category-row" role="tab" aria-selected="false" aria-controls="${FUNCTIONALITY_CATEGORY_ID}-description">
            <div id="${FUNCTIONALITY_CATEGORY_ID}" class="hs-category-label" aria-label="${categories.functionality.label}" tabindex="0">
              <span>${categories.functionality.label}</span>
              <span id="${FUNCTIONALITY_CATEGORY_ID}-checked" class="hs-modal-checkmark ${!hasToggledFunctionality && 'hs-hidden'}"></span>
              <span id="${FUNCTIONALITY_CATEGORY_ID}-unchecked" class="hs-modal-cross ${hasToggledFunctionality && 'hs-hidden'}"></span>
            </div>
            <div id="${FUNCTIONALITY_CATEGORY_ID}-description" class="hs-category-description hs-hidden" role="tabpanel" role="tabpanel">
              <div class="hs-category-description-header">
                <label class="hs-category-toggle">
                  <input id="${FUNCTIONALITY_TOGGLE_ID}" type="checkbox" ${hasToggledFunctionality && 'checked'}  role="switch" aria-label="${categories.functionality.label}" tabindex="0">
                  <span class="slider"></span>
                </label>
                <h3 aria-hidden="true">${categories.functionality.label}</h3>
              </div>
              <div class="hs-category-description-text">
                ${categories.functionality.description}
             </div>
            </div>
          </div>
        <div class="hs-category-fill"></div>
        </div>
      </div>

      <div id="hs-modal-footer">
        <div id="hs-modal-footer-container">
          <a href="javascript:void(0);" id="hs-modal-save-settings" role="button">${saveSettingsLabel}</a>
          <a href="javascript:void(0);" id="hs-modal-accept-all" role="button">${acceptAllLabel}</a>
        </div>
      </div>
  </div>
</div>
  `;
};